module.exports = __webpack_public_path__ + "static/img/deportes_01.4e175381.jpeg";